import Loading from "../icons/Loading";
import "./IconLoading.css";

const InlineLoading = () => (
	<div className="airwpsync-c-inline-loading"><Loading /></div>
);
export default InlineLoading;
